import { Stack, List, ListItem, ListItemIcon, ListItemText, useMediaQuery, ThemeProvider, createTheme } from '@mui/material';
import PolygonIcon from 'components/icons/Polygon';
import { baseColors } from 'utils/constants';

const theme = createTheme({
  components: {
    MuiListItem: {
      styleOverrides: {
        root: {
          alignItems: 'flex-start'
        }
      }
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          margin: '4px 0px'
        }
      }
    },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          fontSize: '14px',
          paddingLeft: '5px'
        }
      }
    }
  }
});

const TopFooterMenu = () => {
  //const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // スマホサイズ判定
  const menuLists1 = [
    { title: 'ホーム', src: 'https://www.wifi-tokyo-rentalshop.com/' },
    { title: '初めてのWi-Fiレンタル', src: 'https://www.wifi-tokyo-rentalshop.com/first-time/' },
    { title: 'レンタル料金表', src: 'https://www.wifi-tokyo-rentalshop.com/price-table-2/' },
    { title: 'wi-Fi接続方法', src: 'https://www.wifi-tokyo-rentalshop.com/connection-method-of-502hw/' },
    { title: 'wi-Fi返却方法', src: 'https://www.wifi-tokyo-rentalshop.com/how-to-return-wifi-router/' },
    { title: 'よくある質問', src: 'https://www.wifi-tokyo-rentalshop.com/qanda/' }
  ];
  const menuLists2 = [
    { title: '安心保障について', src: 'https://www.wifi-tokyo-rentalshop.com/service-campaign/anshin-hosyou/' },
    { title: 'Wi-Fiレンタルの延長を希望される方へ', src: 'https://www.wifi-tokyo-rentalshop.com/extension/' },
    { title: 'ホテル受け取り', src: 'https://www.wifi-tokyo-rentalshop.com/service-campaign/hotel/' },
    { title: '店舗受け取り', src: 'https://www.wifi-tokyo-rentalshop.com/service-campaign/store-receipt/' },
    { title: '空港受け取り', src: 'https://www.wifi-tokyo-rentalshop.com/service-campaign/airport/' },
    { title: '入院中のWi-Fi環境', src: 'https://www.wifi-tokyo-rentalshop.com/service-campaign/in-hospital/' }
  ];
  const menuLists3 = [
    { title: '請求書払い・数量割引', src: 'https://www.wifi-tokyo-rentalshop.com/service-campaign/corporate-contract/' },
    { title: '利用規約', src: 'https://www.wifi-tokyo-rentalshop.com/terms-of-service/' },
    { title: '特定商取引の表記', src: 'https://www.wifi-tokyo-rentalshop.com/sct-law/' },
    { title: 'アフェリエイターさん募集', src: 'https://www.wifi-tokyo-rentalshop.com/affiliate-wanted/' },
    { title: '個人情報保護方針', src: 'https://www.wifi-tokyo-rentalshop.com/privacy-policy/' },
    { title: '会社概要', src: 'https://www.wifi-tokyo-rentalshop.com/company-profile/' }
  ];

  const displayList = (menuLists: any[]) => (
    <List
      sx={{
        flexGrow: 1, // 均等にスペースを埋める
        width: { xs: '50%', sm: 'auto' },
        minWidth: 0 // フレックスアイテムの幅を適切に調整
      }}
    >
      {menuLists.map((item, index) => (
        <ListItem key={index} sx={{ padding: '3px 15px' }}>
          <ListItemIcon sx={{ minWidth: '20px' }}>
            <PolygonIcon style={{ color: baseColors.red, width: '0.85em' }} />
          </ListItemIcon>
          <ListItemText>
            <a href={item.src}>{item.title}</a>
          </ListItemText>
        </ListItem>
      ))}
    </List>
  );

  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{
        justifyContent: 'center',
        alignItems: 'flex-start',
        padding: { xs: '0px', sm: '20px' }
      }}
    >
      <ThemeProvider theme={theme}>
        {displayList(menuLists1)}
        {displayList(menuLists2)}
        {!isMobile && displayList(menuLists3)} {/* スマホでは非表示 */}
      </ThemeProvider>
    </Stack>
  );
};

export default TopFooterMenu;
